"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var YandexMapLoader_1 = require("./YandexMapLoader");
var YandexMapOffices_1 = require("./YandexMapOffices");
function YandexMap(props) {
    return (react_1.default.createElement(YandexMapLoader_1.YandexMapLoader, null,
        react_1.default.createElement(YandexMapOffices_1.YandexMap, tslib_1.__assign({}, props))));
}
exports.YandexMap = YandexMap;
